module.exports = __webpack_public_path__ + "static/og-placard-7409546cd3bf1eac056b5d5c9a8ecb55.jpg";